<template>
    <div class="look__item" @click="openLookModal()">
        <lazy-img picture-class=""
                  :image-url="image"
                  :alt="name"
                  :title="name">
        </lazy-img>
        <button class="btn btn-primary look__btn">Zum Look<span v-if="showLoading"> (lädt...)</span></button>

        <div class="category-item__quick-view-item-modal category-item__quick-view-item-modal--looks" v-show="showItemModal" ref="quickViewModal">
            <a href="#" class="btn-close" @click.prevent="closeLookModal()"><i class="fa fa-close" aria-hidden="true"></i></a>
            <div class="look__item-modal-wrapper">
                <img :src="image" :alt="item.texts.name2 + ' Look'" class="look-img">
                <div class="category-item__look-rightside">
                    <div v-if="loadingItemData" class="category-item__look-rightside--loading-overlay"><span>Artikel wird geladen...</span></div>
                    <!-- itemimagecarousel -->
                    <div class="category-item__quick-view-item-image" v-if="showItemModal">
                        <item-image-carousel
                                :max-quantity="8"
                                image-url-accessor="urlMiddle"
                                :show-thumbs="true"
                                :show-dots="false"
                                animation-style=""
                                :enable-lightbox="false"
                                :plugin-path="pluginPath"
                                :thumbs-horizontal="true"
                                :category-item-data="item">
                        </item-image-carousel>
                    </div>
                    <div class="category-item__quick-view-info" v-if="showItemModal">
                        <div class="category-item__quick-view-headline">{{ item.texts.name2 }}</div>
                        <div class="category-item__quick-view-price-wrapper">
                    <span class="category-item__quick-view-price">


                            <div class="prices">
                                <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value" class="price-view-port">
                                    <del class="crossprice" v-if="item.prices.specialOffer">
                                        {{ item.prices.default.unitPrice.formatted }}
                                    </del>
                                    <del class="crossprice" v-else>
                                        {{ item.prices.rrp.unitPrice.formatted }}
                                    </del>
                                </div>

                                <div class="price">
                                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                                </div>
                            </div>
                    </span>
                            <span class="category-item__quick-view-txt category-item__quick-view-txt--after-price">&nbsp;&nbsp;&nbsp;&nbsp;inkl. MwSt., zzgl. <a href="/zahlung-und-versand" title="Versand">Versand</a></span>
                        </div>
                        <div class="category-item__quick-view-txt">Artikelnummer:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.variation.number }}</div>
                        <div class="category-item__quick-view-details">
                            <a :href="item | itemURL(false)" :title="item.texts.name2">Artikeldetails</a>
                        </div>

                        <hr>

                        <div v-if="attributesMap.length">
                            <variation-select-category :attributes="attributesMap"
                                                       :variations="variationsMap"
                                                       :item-variations="variations"
                                                       :variation-id="mainvariationid"
                                                       :selected-variation="item" v-on:childToParent="onChildClick">
                            </variation-select-category>
                        </div>
                    </div>
                    <div class="category-item__quick-view-basket-row" v-if="showItemModal">
                        <div class="category-item__quick-view-basket-col--left" >
                            <variation-select-category v-if="attributesMap"
                                                       :attributes="attributesMap"
                                                       :variations="variationsMap"
                                                       :item-variations="variations"
                                                       :variation-id="mainvariationid"
                                                       :selected-variation="item"
                                                       :is-size="true"
                            ></variation-select-category>

                        </div>
                        <div class="category-item__quick-view-basket-col--right">
                            <QuantityInput
                                    :value="qty"
                                    @quantity-change="updateQty"
                            />
                        </div>
                        <div class="category-item__quick-view-basket-col--left od-wishlist">
                            <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
                        </div>
                        <div class="category-item__quick-view-basket-col--right od-basket">
                            <add-to-basket v-if="item"
                                           :variation-id="item.variation.id"
                                           :item-id-category="item.item.id"
                                           :is-salable="!!item.filter && item.filter.isSalable"
                                           :has-children="!!item.filter && item.filter.hasActiveChildren"
                                           :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                           :minimum-quantity="item.variation.minimumOrderQuantity"
                                           :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                           :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                           :has-order-properties="item.hasOrderProperties"
                                           :use-large-scale="false"
                                           :show-quantity="false"
                                           :item-url="item | itemURL"
                                           :has-price="item | hasItemDefaultPrice"
                                           :propQuantity="qty"
                            >
                            </add-to-basket>
                        </div>
                    </div>
                </div>
            </div>
            <div class="category-item__look-items">
                <div class="category-item__look-items-title">weitere artikel des looks</div>
                <div class="category-item__look-items-swiper">
                    <div class="swiper-container" ref="itemSwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="loadItem()">
                                <div class="category-item__look-item">
                                    <div class="category-item__look-items-img-wrap">
                                        <img :alt="mainItem.texts.name2" :src="mainItem.images.sorted[0].urlSecondPreview">
                                    </div>
                                    <div class="category-item__look-item-name">{{ mainItem.texts.name2 }}</div>
                                    <div class="category-item__look-item-price">{{ mainItem.prices.default.unitPrice.formatted }}</div>
                                </div>
                            </div>
                            <div class="swiper-slide" @click="loadItem(item)" v-for="(item, key) in initiallyUsedEntries" v-if="item.data" :class="'swiper-slide--' + key">
                                <div class="category-item__look-item">
                                    <div class="category-item__look-items-img-wrap">
                                        <img :alt="item.data.texts.name2" :src="item.data.images.sorted[0].urlSecondPreview">
                                    </div>
                                    <div class="category-item__look-item-name">{{ item.data.texts.name2 }}</div>
                                    <div class="category-item__look-item-price">{{ item.data.prices.default.unitPrice.formatted }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="category-item__thumb-swiper-prev"><i class="icon-left"></i></div>
                    <div class="category-item__thumb-swiper-next"><i class="icon-right"></i></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import ApiService from "ceres/app/services/ApiService";
    import QuantityInput from "../item/QuantityInput.vue";
    import CategoryImageCarousel from "ceres/app/components/itemList/CategoryImageCarousel.vue";
    import ItemStoreSpecial from "../itemList/ItemStoreSpecial.vue";
    import { Swiper } from 'swiper';

    export default{
        components: {
            CategoryImageCarousel,
            ItemStoreSpecial,
            QuantityInput
        },
        props:{
            entries:{
                type: Array,
                default: () => []
            },
            image:{
                type: String,
                default: ""
            },
            mainvariationid:{
                type: Number,
                default: 0
            },
            itemid:{
                type: Number,
                default: 0
            },
            name:{
                type: String,
                default: ""
            },
            itemData:{
                type: Object
            }
        },

        created(){
            this.mainItem = this.item;
            if(this.mainItem.images.variation && this.mainItem.images.variation.length > 0){
                this.mainItem.images.sorted = this.mainItem.images.variation.sort((a, b) => a.position - b.position);
            }else{
                this.mainItem.images.sorted = this.mainItem.images.all.sort((a, b) => a.position - b.position);
            }
        },

        mounted()
        {
            this.currentUrl = window.location.href;

            this.$nextTick(() =>
            {
                //this.loadVariationImages();
                //this.loadItems();
                //this.mainItem = this.item;
                this.initiallyUsedEntries = this.entries;
            });
        },

        data(){
            return {
                variations: {},
                variationsMap: [],
                isLoadingVariations: false,
                showItemModal: false,
                pluginPath: App.pluginPath,
                attributesMap: [],
                initialItemId: 0,
                qty:1,
                currentUrl: "",
                registeredItems: [],
                mainItem: {},
                doneWithVariations: false,
                doneWithItems: false,
                modalInitialized: false,
                showLoading: false,
                loadingItemData: false,
                initiallyUsedEntries: [],
                overlayItem: undefined,
                changeFromVariationSelect: 0
            }
        },

        methods:{
            onChildClick (value) {
                this.changeFromVariationSelect = value
            },

            updateQty(num){
                this.qty = num;
            },

            loadVariations(){
                let varIds = "";
                let itemIds = "";

                for(let key in this.entries){
                    varIds += this.entries[key].variationID;
                    itemIds += this.entries[key].entryItemID;
                    if(key < this.entries.length - 1){
                        varIds += ",";
                        itemIds += ",";
                    }
                }

                this.isLoadingVariations = true;

                // pro entry die entryItemID + this.itemid (main item) für fallbacks

                ApiService.get("/rest/stylebreaker/itemlist?variationIds="+ this.mainvariationid+","+varIds+"&fallbackItemIds="+this.itemid+","+itemIds)
                    .done(data => {

                        this.variations = data.requestedVariation.itemList;
                        this.variationsMap = data.variationsMap[0];
                        this.initialItemId = data.itemList[0].documents[0].data.item.id;

                        for(let key in this.variations){

                            if(typeof this.variations[key].documents[0] !== "undefined"){
                                let previewImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlPreview"
                                )).slice(0, 1);

                                this.variations[key].previewImage = previewImages[0];

                                let bigImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlMiddle"
                                )).slice(0, 1);

                                this.variations[key].bigImage = bigImages[0];
                            }else{
                                this.variations[key].bigImage = "";
                            }
                        }

                        // anpassen des variationsArrays
                        let vars = this.variations;
                        let newVars = [];
                        let colorValueIdsUsed = []; // wenn id 5 oder 12 ist, valueIds reinschreiben

                        for(let key in vars){
                            for(let innerKey in vars[key].documents[0].data.attributes){
                                if([5, 12, 9, 11].indexOf(vars[key].documents[0].data.attributes[innerKey].attributeId) > -1){
                                    //if(colorValueIdsUsed.indexOf(vars[key].documents[0].data.attributes[innerKey].valueId) < 0){
                                    newVars.push(vars[key]);
                                    colorValueIdsUsed.push(vars[key].documents[0].data.attributes[innerKey].valueId)
                                    //}
                                }
                            }
                        }

                        this.variations = newVars;

                        for(let key in data.itemList){
                            if(key > 0){ // exclude main item
                                if(data.itemList[key].documents.length > 0){
                                    this.initiallyUsedEntries[key-1].data = data.itemList[key].documents[0].data;

                                    // sort images
                                    if(this.initiallyUsedEntries[key-1].data.images.variation && this.initiallyUsedEntries[key-1].data.images.variation.length > 0){
                                        this.initiallyUsedEntries[key-1].data.images.sorted = this.initiallyUsedEntries[key-1].data.images.variation.sort((a, b) => a.position - b.position);
                                    }else{
                                        this.initiallyUsedEntries[key-1].data.images.sorted = this.initiallyUsedEntries[key-1].data.images.all.sort((a, b) => a.position - b.position);
                                    }
                                }
                            }
                        }

                        this.doneWithVariations = true;
                        this.doneWithItems = true;


                    }).fail((err)=> console.log(err));
            },

            loadItem(item){

                let itemData = {};
                itemData.data = this.item;
                item = item || this.mainItem;
                if(typeof item.data === "undefined"){
                    item.data = this.mainItem;
                }

                this.loadingItemData = true;

                let varId = typeof item.data !== "undefined" ? item.data.variation.id : item.variation.id;

                ApiService.get("/rest/stylebreaker/itemlist?variationId="+ varId)
                    .done(data => {
                        item.variations = data.itemList;
                        item.variationsMap = data.variationsMap;

                        let docs = [];
                        docs.push({"data": item.data});

                        /*this.$store.dispatch(`${item.data.item.id}/loadVariation`, item.data.variation.id).then(variation =>
                        {
                            this.$store.commit("setOverlayItem", item.data);
                            // set the overlay item after variation changed
                            document.dispatchEvent(new CustomEvent("onVariationChanged",
                                {
                                    detail:
                                        {
                                            attributes: item.data.attributes,
                                            documents: docs
                                        },
                                    itemId: item.data.item.id
                                }));

                            this.variationsMap = item.variationsMap;
                            this.variations = item.variations;
                            this.attributesMap = [];
                            this.setAttributes();
                        });*/

                        if(this.registeredItems.indexOf(docs[0].data.item.id) == -1){
                            this.$store.dispatch("registerItem", docs[0]);
                            this.registeredItems.push(docs[0].data.item.id);
                        }

                        this.$store.commit(`${item.data.item.id}/variationSelect/setOverlayItem`, item.data);
                        //this.$store.commit("setMainItemId", docs[0].data.item.id);

                        document.dispatchEvent(new CustomEvent("onVariationChanged",
                            {
                                detail:
                                    {
                                        attributes: item.data.attributes,
                                        documents: docs,
                                        itemId: item.data.item.id
                                    },

                            }));
                        this.variationsMap = item.variationsMap;
                        this.variations = item.variations;
                        this.attributesMap = [];

                        for(let key in this.variations){

                            if(typeof this.variations[key].documents[0] !== "undefined"){
                                let previewImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlPreview"
                                )).slice(0, 1);

                                this.variations[key].previewImage = previewImages[0];

                                let bigImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlMiddle"
                                )).slice(0, 1);

                                this.variations[key].bigImage = bigImages[0];
                            }else{
                                this.variations[key].bigImage = "";
                            }
                        }

                        // anpassen des variationsArrays
                        let vars = this.variations;
                        let newVars = [];
                        let colorValueIdsUsed = []; // wenn id 5 oder 12 ist, valueIds reinschreiben
                        for(let key in vars){
                            for(let innerKey in vars[key].documents[0].data.attributes){
                                if([5, 9, 11, 12].indexOf(vars[key].documents[0].data.attributes[innerKey].attributeId) > -1){
                                    //if(colorValueIdsUsed.indexOf(vars[key].documents[0].data.attributes[innerKey].valueId) < 0){
                                    newVars.push(vars[key]);
                                    colorValueIdsUsed.push(vars[key].documents[0].data.attributes[innerKey].valueId)
                                    //}
                                }
                            }
                        }

                        // .selected-attribute
                        /*let selectionValueId = 0;
                        if(this.item.attributes.length > 0 ){
                            // durch gehen und farbe finden
                            let colorAttrIds = [5, 9, 11, 12];
                            let selectionName = "";
                            for(let key in this.item.attributes){
                                if(colorAttrIds.includes(this.item.attributes[key].attributeId)){
                                    selectionName = this.item.attributes[key].value.names.name;
                                    selectionValueId = this.item.attributes[key].valueId;
                                    break;
                                }
                            }

                            $(".selected-attribute").text(selectionName);
                            $('.variation-select__img').removeClass("active");
                            $('.variation-select__img[data-attr-value-id="'+selectionValueId+'"]').addClass("active");
                        }*/

                        let actualVariationAttrSelectionValueId = 0;

                        if(item.data.attributes.length > 0){
                          let actualVariationAttrName = "";
                          let colorAttrIds = [5, 9, 11, 12];
                          for(let key in item.data.attributes){
                            if(colorAttrIds.includes(item.data.attributes[key].attributeId)){
                              actualVariationAttrName = item.data.attributes[key].value.names.name;
                              actualVariationAttrSelectionValueId = item.data.attributes[key].valueId;
                              break;
                            }
                          }

                          if(actualVariationAttrName !== ""){
                            $(".selected-attribute").text(actualVariationAttrName);
                            $('.variation-select__img').removeClass("active");
                            $('.variation-select__img[data-attr-value-id="'+actualVariationAttrSelectionValueId+'"]').addClass("active");
                          }
                        }

                        this.loadingItemData = false;

                        this.variations = newVars;
                        this.overlayItem = this.$store.state.items[item.data.item.id].variationSelect.overlayItem;

                        this.setAttributes(actualVariationAttrSelectionValueId);
                    });

            },

            setAttributes(selectionValueId){
                selectionValueId = selectionValueId || null;

                if(Object.keys(this.attributesMap).length === 0){
                    let usedAttributes = [];
                    let usedValues = [];

                    function getKeyByValue(object, value) {
                        return Object.keys(object).find(keyInner => object[keyInner] === value);
                    }

                    for(let key in this.variations){
                        let varData = this.variations[key].documents[0].data.attributes;

                        for(let keyKey in varData){
                            if(usedAttributes.includes(varData[keyKey].attributeId)){
                                // attr id ist schon in der map, valuesmuss erweitert werden
                                let arrKey = getKeyByValue(usedAttributes, varData[keyKey].attributeId);

                                if(!usedValues.includes(varData[keyKey].value.id)){

                                    usedValues.push(varData[keyKey].value.id);

                                    this.attributesMap[arrKey].values.push({
                                        attributeValueId: varData[keyKey].value.id,
                                        imageUrl: this.variations[key].bigImage,
                                        name: varData[keyKey].value.names.name,
                                        position: varData[keyKey].value.position,
                                    });
                                }

                            }else{
                                usedAttributes.push(varData[keyKey].attributeId);

                                this.attributesMap.push({
                                    attributeId: varData[keyKey].attributeId,
                                    name: varData[keyKey].attribute.names.name,
                                    position: varData[keyKey].attribute.position,
                                    type: varData[keyKey].attribute.typeOfSelectionInOnlineStore,
                                    values: []
                                });

                                if(!usedValues.includes(varData[keyKey].value.id)){

                                    usedValues.push(varData[keyKey].value.id);

                                    //if(typeof this.variations[keyKey] !== "undefined"){
                                        this.attributesMap[keyKey].values.push({
                                            attributeValueId: varData[keyKey].value.id,
                                            //imageUrl: this.variations[keyKey].bigImage,
                                            imageUrl: this.variations[keyKey].bigImage,
                                            name: varData[keyKey].value.names.name,
                                            position: varData[keyKey].value.position,
                                        });
                                    //}
                                }

                            }
                        }
                    }

                    if(selectionValueId != null){
                        setTimeout(function(){
                            $('.variation-select__img').removeClass("active");
                            $('.variation-select__img[data-attr-value-id="'+selectionValueId+'"]').addClass("active");
                        }, 1);
                    }
                }
            },

            initModal(){
                this.modalInitialized = true;
                this.setAttributes();

                let regItem = {};
                regItem.data = this.item;

                if(this.registeredItems.indexOf(regItem.data.item.id) == -1){
                    this.$store.dispatch("registerItem", regItem);
                    this.registeredItems.push(regItem.data.item.id);
                }

                this.showItemModal = true;
                $(this.$refs.quickViewModal).detach().appendTo('body');
                $('body').addClass("quick-view-open");
                $('body').append("<div class='modal-backdrop'></div>");

                this.$nextTick(() =>
                {
                    this.initSwiper();
                });
            },

            openLookModal(){
                // open modal mit item data, get attributs data
                this.showLoading = true;

                if(this.doneWithItems && this.doneWithVariations){
                    this.doneWithItems = false;
                    this.doneWithVariations = false;
                    this.modalInitialized = false;

                    this.variations = {};
                    this.variationsMap = [];
                    this.attributesMap = [];
                    this.initialItemId = 0;

                    this.loadVariations();
                    //this.loadVariationImages();
                    //this.loadItems();
                }else{
                    this.loadVariations();
                    //this.loadVariationImages();
                    //this.loadItems();
                }
            },

            closeLookModal(){
                $(this.$refs.quickViewModal).detach().appendTo(this.$refs.article);
                this.showItemModal = false;
                $('body').removeClass("quick-view-open");
                $('.modal-backdrop').remove();

                window.history.pushState("object or string", "Title", this.currentUrl);
                this.$store.commit(`${this.initialItemId}/variationSelect/setOverlayItem`, {});
                this.overlayItem = {};
            },

            orderByPosition(list)
            {
                return list.sort(
                    (entryA, entryB) =>
                    {
                        if (entryA.position > entryB.position)
                        {
                            return 1;
                        }
                        if (entryA.position < entryB.position)
                        {
                            return -1;
                        }

                        return 0;
                    });
            },

            initSwiper(){
                let swiperRef = this.$refs.itemSwiper;

                const swiper = new Swiper(".category-item__look-items-swiper .swiper-container", {
                    navigation: {
                        nextEl: $(swiperRef).closest('.category-item__look-items-swiper').find(".category-item__thumb-swiper-next")[0],
                        prevEl: $(swiperRef).closest('.category-item__look-items-swiper').find(".category-item__thumb-swiper-prev")[0]
                    },
                    lazy: true,
                    slidesPerView: 2,
                    spaceBetween: 20,
                    loop: false,
                    allowTouchMove: false,
                    breakpoints: {
                        992: {
                            slidesPerView: 4,
                            spaceBetween: 40
                        }
                    },
                });
            },

            getVariationImage(images){
                let imgArr = images.variation;

                if(imgArr.length > 0){
                    //imgArr.sort((a, b) => a.position - b.position);
                }else{
                    imgArr = images.all;
                    //imgArr.sort((a, b) => a.position - b.position);
                }
                imgArr = images.all;
                return imgArr[0].urlPreview;
            }
        },

        computed:{
            /*overlayItem(){
                if(typeof this.itemId === "undefined"){
                    return undefined;
                }
                return this.$store.state.items[this.itemId].variationSelect.overlayItem
            },*/

            item()
            {
                if(typeof this.overlayItem !== 'undefined' && Object.keys(this.overlayItem).length){ // && this.overlayItem.item.id == this.initialItemId
                    return this.overlayItem;
                }
                return this.itemData;
            },

            ...mapState({
                showNetPrices: state => state.basket.showNetPrices
            })
        },

        watch:
            {
                doneWithVariations(value)
                {
                    if(value && this.doneWithItems && !this.modalInitialized){
                        this.showLoading = false;
                        this.initModal()
                    }
                },

                doneWithItems(value)
                {
                    if(value && this.doneWithVariations && !this.modalInitialized){
                        this.showLoading = false;
                        this.initModal()
                    }
                },

                changeFromVariationSelect(value){
                    if(value){
                        this.overlayItem = this.$store.state.items[value].variationSelect.overlayItem;
                        this.changeFromVariationSelect = 0;
                    }
                }
            }
    }
</script>
